import type { ReactElement } from 'react';
import { ConfigurationCriterion } from 'src/features/configuration/configurationCriteria/ConfigurationCriterion';
import { ConfigurationCriteriaProductsContainer } from 'src/features/configuration/configurationCriteria/configurationCriteriaProducts/ConfigurationCriteriaProductsContainer';
import { ConfigurationCriteriaEnum } from 'src/features/configuration/configurationCriteria/enums/ConfigurationCriteriaEnum';
import { useConfigurationCriteria } from 'src/features/configuration/configurationCriteria/hooks/useConfigurationCriteria';
import { useSessionCriteriaQuery } from 'src/services/api/getOpenSessionCriteria';

type ConfigurationCriteriaProps = {
  sessionId: string;
};

export function ConfigurationCriteria({
  sessionId,
}: ConfigurationCriteriaProps): ReactElement {
  const { data } = useSessionCriteriaQuery(sessionId);
  const { getCriterion } = useConfigurationCriteria(data);

  return (
    <div className='flex w-full flex-col gap-10'>
      {Object.values(ConfigurationCriteriaEnum).map((criterionKey) => (
        <ConfigurationCriterion
          criterion={getCriterion(criterionKey)}
          criterionKey={criterionKey}
          key={criterionKey}
        />
      ))}
      <ConfigurationCriteriaProductsContainer />
    </div>
  );
}
